export default __webpack_public_path__ + "b3be074fb2076db8975bb52e74184b34.png";